import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IUserRequest } from '../interfaces/user-request';
import { IUserRequestFilter } from '../interfaces/user-request-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

export interface CreatePasswordRequest {
  userRequestId: string;
  ticket: string;
  password: string;
}

@Injectable({ providedIn: 'root' })
export class UserRequestService extends EditService<IUserRequest, IUserRequestFilter> {
  url = '/api/userrequest';
  entityTitle = 'UserRequest';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public sendRequest(item: IUserRequest): Promise<any> {
    let successMsg =
      'Your request has been sent for registration. You will be notified when it has been processed. ';

    return this.handleRequest(
      this.http.post(`${this.url}/sendRequest`, item),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    ).then(this.extractData);
  }

  public confirm(item: IUserRequest, isResent: boolean): Promise<boolean> {
    let successMsg = isResent ? 'Invitation Resent' : this.entityTitle + 'updated.';
    return this.handleRequest(
      this.http.post(`${this.url}/confirm/${item.id}`, {}),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    ).then(this.extractData);
  }

  public refuse(item: any): Promise<boolean> {
    return this.handleRequest(
      this.http.post(`${this.url}/refuse`, item),
      this.handlersFactory.getForUpdate(this.entityTitle),
    ).then(this.extractData);
  }

  public checkTicket(requestId: string, ticket: string): Promise<any> {
    return this.handleRequest(
      this.http.get(`${this.url}/check-ticket/${requestId}/${ticket}`),
      this.handlersFactory.getForReadAll(),
    ).then(this.extractData);
  }

  public createPassword(item: CreatePasswordRequest): Promise<any> {
    return this.handleRequest(
      this.http.post(`${this.url}/account-registration`, item),
      this.handlersFactory.getForUpdate(this.entityTitle),
    ).then(this.extractData);
  }
}
